'use strict';

var _slicedToArray = require("/usr/src/app/www/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

module.exports = function (object, predicate) {
  var result = {};
  var isArray = Array.isArray(predicate);

  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (isArray ? predicate.includes(key) : predicate(key, value, object)) {
      result[key] = value;
    }
  }

  return result;
};